module.exports = __webpack_public_path__ + "img/logo_vertical.0eba580e.png";